import { JsonapiEntity, attribute, entity } from 'jsonapi-transformers';

import { Loadable } from '®shared/data';

@entity({ type: 'pages' })
export class PageResource extends JsonapiEntity<PageResource> {
  @attribute() content: string;
  @attribute() title: string;
  @attribute() uri: string;
}

export interface LoadablePageResource extends Loadable<PageResource> {}
